/* #1142 - MY PRODUCTS: draws the signed-in buyer's products from #myp-data (their orders, from Liquid) and #myp-catalog
   (what each product is, filled by Website/render/my_products.py), then asks the licence service for each order's
   computers and lets a REMOVE free one. The service answers the store's own pages only (CORS); every request carries
   the same proof the plugin's Activate panel uses: the order's email and number. Website/render/my_products.py --check
   runs this file against the real service code in headless Edge. */
(function () {
  var root = document.getElementById('myp');
  if (!root) return;
  var data, cat;
  try {
    data = JSON.parse(document.getElementById('myp-data').textContent);
    cat = JSON.parse(document.getElementById('myp-catalog').textContent);
  } catch (err) {                                           // never a blank page: the account has the same orders
    root.innerHTML = '<header class="myp__head"><p class="ea-label myp__label">My products</p><h1 class="myp__h">Your products.</h1>' +
      '<p class="myp__sub">This page could not load just now. Your orders and their downloads are in <a href="/account">your account</a>.</p></header>';
    return done();
  }
  var products = cat.products || {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function digits(name) { return String(name || '').replace(/\D/g, '').replace(/^0+(?=\d)/, ''); }
  function day(iso) {
    var d = new Date(String(iso) + 'T12:00:00');
    return isNaN(d) ? String(iso) : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstChild; }

  // ── the products: one row per product, however many orders hold it ──────────────────────────────────────────
  var live = (data.orders || []).filter(function (o) {
    return !o.cancelled && o.status !== 'refunded' && o.status !== 'voided';
  });
  var rows = {}, keys = [];
  live.forEach(function (o) {
    (o.items || []).forEach(function (li) {
      var key = li.handle || 'title:' + li.title;
      var r = rows[key];
      if (!r) { r = rows[key] = { key: key, handle: li.handle, title: li.title, type: li.type, image: li.image, orders: [] }; keys.push(key); }
      if (r.orders.indexOf(o) < 0) r.orders.push(o);
    });
  });
  if ((rows.aio || rows['aio-bundle']) && rows['aio-trial']) keys.splice(keys.indexOf('aio-trial'), 1);   // the same zip, bought
  var order = cat.order || [];
  keys.sort(function (a, b) {
    var ia = order.indexOf(a), ib = order.indexOf(b);
    if (ia >= 0 || ib >= 0) return (ia < 0 ? 1e3 : ia) - (ib < 0 ? 1e3 : ib);
    return rows[a].title.localeCompare(rows[b].title);
  });

  // ── the page ────────────────────────────────────────────────────────────────────────────────────────────────
  var head;
  if (!data.signedIn) {
    head = '<header class="myp__head"><p class="ea-label myp__label" data-ea-reveal>My products</p>' +
      '<h1 class="myp__h" data-ea-reveal="1">Your products.</h1>' +
      '<p class="myp__sub" data-ea-reveal="2">Sign in with the email you bought with. Your downloads, your manuals, your licence and the computers using it are all here.</p>' +
      '<div class="myp__acts" data-ea-reveal="3"><a class="ea-btn ea-btn--solid" href="' + esc(data.signIn) + '">Sign in</a>' +
      '<a class="ea-btn ea-btn--line" href="/products/aio-trial">Try AIO free</a></div></header>';
    root.innerHTML = head;
    return done();
  }
  var who = '<p class="myp__who" data-ea-reveal="2">Signed in as ' + esc(data.email) + '<i>/</i><a href="' + esc(data.account) +
    '">Orders and receipts</a><i>/</i><a href="' + esc(data.logout) + '">Sign out</a></p>';
  if (!keys.length) {
    root.innerHTML = '<header class="myp__head"><p class="ea-label myp__label" data-ea-reveal>My products</p>' +
      '<h1 class="myp__h" data-ea-reveal="1">' + (data.name ? 'Hi, ' + esc(data.name) + '.' : 'Your products.') + '</h1>' + who +
      '<p class="myp__sub" data-ea-reveal="2">Nothing here yet. Whatever you buy or download from Essentia Audio shows up on this page, ready to download.</p>' +
      '<div class="myp__acts" data-ea-reveal="3"><a class="ea-btn ea-btn--solid" href="/products/aio">See AIO</a>' +
      '<a class="ea-btn ea-btn--line" href="/products/aio-trial">Try AIO free</a></div></header>';
    return done();
  }
  head = '<header class="myp__head"><p class="ea-label myp__label" data-ea-reveal>My products</p>' +
    '<h1 class="myp__h" data-ea-reveal="1">' + (data.name ? 'Hi, ' + esc(data.name) + '.' : 'Your products.') + '</h1>' + who +
    '<p class="myp__sub" data-ea-reveal="2">Everything you own, ready to download. Your licence is your email and your order number, and this is where you move it to a new computer.</p></header>';
  var index = keys.length >= 4 ? '<ul class="myp__index" data-ea-reveal="3">' + keys.map(function (k) {
    var p = products[k];
    return '<li><a href="#p-' + esc(k.replace(/[^a-z0-9-]/gi, '')) + '">' + esc(p ? p.name : rows[k].title) + '</a></li>';
  }).join('') + '</ul>' : '';
  root.innerHTML = head + index + '<div class="myp__list">' + keys.map(row).join('') + '</div>' + help();

  function art(r, p) {
    if (p && p.art === 'four') {
      return '<div class="myp-row__art myp-row__art--four">' + p.four.map(function (u) {
        return '<img src="' + esc(u) + '" alt="" width="1200" height="696" loading="lazy">';
      }).join('') + '</div>';
    }
    if (p && p.art) {
      var shot = /shot/.test(p.art);
      return '<div class="myp-row__art' + (shot ? ' myp-row__art--shot' : '') + '"><img src="' + esc(p.art) + '"' +
        (p.art2x ? ' srcset="' + esc(p.art) + ' 600w, ' + esc(p.art2x) + ' 1200w" sizes="(max-width: 900px) 92vw, 440px"' : '') +
        ' alt="' + esc(p.name) + '" width="' + (shot ? 2000 : 1200) + '" height="' + (shot ? 1286 : 696) + '" loading="lazy">' +
        (p.kind === 'trial' ? '<span class="myp-row__tag">7 DAYS</span>' : '') + '</div>';
    }
    return '<div class="myp-row__art myp-row__art--cover">' +
      (r.image ? '<img src="' + esc(r.image) + '" alt="' + esc(r.title) + '" width="720" height="720" loading="lazy">' : '') + '</div>';
  }

  function row(k) {
    var r = rows[k], p = products[k], o0 = r.orders[0];
    var kind = p ? { plugin: 'Plugin', bundle: 'Bundle', trial: 'Free trial', beta: 'Beta' }[p.kind] : ({ VST: 'Plugin' }[r.type] || r.type || 'Download');
    var ver = p ? '<span>/</span><b class="myp-ver" data-release="' + esc(p.release) + '">Version ' + esc(cat.version) + '</b>' : '';
    var acts = '<a class="ea-btn ea-btn--solid" href="' + esc(o0.url) + '">Download</a>';
    if (p && p.manual) acts += '<a class="ea-btn ea-btn--line" href="' + esc(p.manual) + '" target="_blank" rel="noopener">Manual <small>PDF</small></a>';
    if (p && p.kind === 'trial') acts += '<a class="ea-btn ea-btn--line" href="/products/aio">Buy AIO</a>';
    var small = p ? '<p class="myp-row__small">' + (p.kind === 'trial'
        ? '7 days on each computer, from the first time you open it. Buy AIO later and activate this same install: nothing to reinstall.'
        : p.kind === 'beta' ? 'One zip for Windows and Mac, with the manual inside. It stops on the day AIO is released.'
        : 'One zip for Windows and Mac, with the manual inside.') +
        ' <a href="#myp-req">System requirements</a><span class="myp-new"></span></p>' : '';
    if (!(p && p.licence)) small += '<p class="myp-row__small">' + (r.orders.length > 1 ? 'In ' + r.orders.length + ' orders: ' : 'Order ') +
      r.orders.map(function (o) { return '<a href="' + esc(o.url) + '">' + esc(o.name) + '</a>, ' + esc(day(o.date)); }).join('; ') + '</p>';
    var inc = p && p.includes ? '<p class="myp-row__inc">' + p.includes.map(function (i) {
      return '<a href="' + esc(i.href) + '">' + esc(i.name) + '</a>'; }).join(' ') + '</p>' : '';
    var lic = p && p.licence ? r.orders.map(function (o) { return licence(o, p, r.orders.length > 1); }).join('') : '';
    return '<article class="myp-row" id="p-' + esc(k.replace(/[^a-z0-9-]/gi, '')) + '" data-ea-reveal>' + art(r, p) +
      '<div class="myp-row__main"><p class="ea-label myp-row__kind">' + esc(kind) + ver + '</p>' +
      '<h2 class="myp-row__name">' + esc(p ? p.name : r.title) + '</h2>' +
      (p && p.line ? '<p class="myp-row__line">' + esc(p.line) + '</p>' : '') + inc +
      '<div class="myp-row__acts">' + acts + '</div>' + small + lic + '</div></article>';
  }

  function licence(o, p, many) {
    return '<div class="myp-lic" data-order="' + esc(o.name) + '" data-licence="' + esc(p.licence) + '">' +
      '<h3 class="ea-label myp-lic__title">Your licence' + (many ? ' / order ' + esc(o.name) : '') + '</h3>' +
      '<dl class="myp-lic__dl"><dt>Email</dt><dd>' + esc(data.email) + '</dd>' +
      '<dt>Order number</dt><dd><span>' + esc(o.name) + '</span><button class="myp-copy" type="button" data-copy="' + esc(o.name) + '">Copy</button></dd>' +
      '<dt>Computers</dt><dd class="myp-seats"><span class="myp-seats__text">Checking...</span></dd></dl>' +
      '<ul class="myp-comps"></ul>' +
      '<p class="myp-lic__note">Type both into ' + esc(p.kind === 'bundle' ? 'AIO\'s or any synth\'s' : p.name + '\'s') +
      ' Activate panel - that is the whole licence, nothing to keep. The code of the computer you are on is at the bottom of that panel.</p>' +
      '<p class="myp-lic__say" role="status"></p></div>';
  }

  function help() {
    return '<div class="myp-help" data-ea-reveal><h2>Good to know</h2><div class="myp-help__grid">' +
      '<div><b>A new computer</b><p>Remove the old one here, or from its Activate panel, and its place is free at once. Then activate the new one with the same email and order number.</p></div>' +
      '<div><b>Updates are free</b><p>The plugin tells you when a new version is out. Download it from this page and install it over the old one.</p></div>' +
      '<div><b>Need a hand?</b><p>Write to us from <a href="/pages/contact">Support</a> with your order number, and we will sort it out.</p></div>' +
      '</div></div>';
  }

  // ── the computers on each licence: one ask for every order that holds one ──────────────────────────────────
  var blocks = [].slice.call(root.querySelectorAll('.myp-lic'));
  var asked = blocks.map(function (b) { return b.getAttribute('data-order'); }).filter(function (n, i, a) { return a.indexOf(n) === i; });
  function post(op, body) {                                // a plain-text body: a "simple" request, no preflight round trip
    return fetch(cat.service + '/v1/' + op, { method: 'POST', body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); });
  }
  function load() {
    blocks.forEach(function (b) { b.querySelector('.myp-seats__text').textContent = 'Checking...'; say(b, ''); });
    post('computers', { email: data.email, orders: asked }).then(function (j) {
      if (!j || !j.ok) throw j;
      var by = {};
      (j.orders || []).forEach(function (o) { by[o.order] = o; });
      blocks.forEach(function (b) {
        var o = by[digits(b.getAttribute('data-order'))];
        var lic = o && (o.licences || []).filter(function (l) { return l.product === b.getAttribute('data-licence'); })[0];
        if (!o || o.error || !lic) {
          b.querySelector('.myp-seats__text').textContent = 'Not in the licence records yet';
          say(b, 'If you bought it a moment ago, this fills in within a few minutes. Activating works either way.');
          return;
        }
        draw(b, lic, o.removals_left, j.removals_per_30_days);
      });
    }).catch(function () {
      blocks.forEach(function (b) {
        b.querySelector('.myp-seats__text').textContent = '-';
        say(b, 'The licence service did not answer just now. Your licence works as always. <button class="myp-copy" type="button" data-retry>Try again</button>', true);
      });
    });
  }
  function say(b, html, error) {
    var s = b.querySelector('.myp-lic__say');
    s.innerHTML = html;
    s.classList.toggle('is-error', !!error);
  }
  function draw(b, lic, left, per) {
    b._lic = lic; b._left = left; b._per = per;
    var used = lic.machines.length, all = lic.machines_allowed;
    var meter = '';
    for (var i = 0; i < all; i++) meter += '<i' + (i < used ? ' class="is-on"' : '') + '></i>';
    b.querySelector('.myp-seats').innerHTML = '<span class="myp-meter" aria-hidden="true">' + meter + '</span>' +
      '<span class="myp-seats__text"><b>' + used + '</b> of ' + all + ' in use</span>';
    b.querySelector('.myp-comps').innerHTML = lic.machines.map(function (m) {
      return '<li data-machine="' + esc(m.machine) + '"><span class="myp-comps__code">' + esc(m.machine) + '</span>' +
        '<span class="myp-comps__since">Since ' + esc(day(m.since)) + '</span>' +
        '<button class="myp-remove" type="button"' + (left > 0 ? '' : ' disabled') + '>Remove</button></li>';
    }).join('');
    if (!used) say(b, 'Not activated on any computer yet.');
    else if (left > 0) say(b, 'You can remove ' + left + (left === 1 ? ' more computer' : ' more computers') + ' this month.');
    else say(b, 'This order has removed ' + per + ' computers in the last 30 days, the most it allows. <a href="/pages/contact">Support</a> can free another.', true);
  }

  root.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-copy]');
    if (copy) {
      var text = copy.getAttribute('data-copy');
      (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject()).then(function () {
        copy.textContent = 'Copied';
        setTimeout(function () { copy.textContent = 'Copy'; }, 1600);
      }, function () {});
      return;
    }
    if (e.target.closest('[data-retry]')) return load();
    var btn = e.target.closest('.myp-remove');
    if (!btn || btn.disabled) return;
    var b = btn.closest('.myp-lic'), li = btn.closest('li');
    if (!btn.classList.contains('is-armed')) {                 // the plugin's REMOVE asks again; so does this
      root.querySelectorAll('.myp-remove.is-armed').forEach(function (x) { x.classList.remove('is-armed'); x.textContent = 'Remove'; });
      btn.classList.add('is-armed');
      btn.textContent = 'Sure? Click again';
      clearTimeout(btn._t);
      btn._t = setTimeout(function () { btn.classList.remove('is-armed'); btn.textContent = 'Remove'; }, 4000);
      return;
    }
    clearTimeout(btn._t);
    btn.classList.remove('is-armed');
    btn.disabled = true;
    btn.textContent = 'Removing...';
    post('deactivate', { email: data.email, order: b.getAttribute('data-order'), machine: li.getAttribute('data-machine'),
                         product: b.getAttribute('data-licence') }).then(function (j) {
      if (!j || !j.ok) {
        btn.disabled = false;
        btn.textContent = 'Remove';
        return say(b, esc((j && j.message) || 'That did not go through. Try again in a minute.'), true);
      }
      li.classList.add('is-gone');
      var lic = b._lic, gone = li.getAttribute('data-machine');
      lic.machines = lic.machines.filter(function (m) { return m.machine !== gone; });
      var left = j.already ? b._left : Math.max(0, b._left - 1);
      setTimeout(function () {
        draw(b, lic, left, b._per);
        say(b, 'Removed. Its place is free now: activate your other computer with this email and order number.');
      }, 380);
    }, function () {
      btn.disabled = false;
      btn.textContent = 'Remove';
      say(b, 'The licence service did not answer just now. Nothing was removed. Try again in a minute.', true);
    });
  });

  if (blocks.length) load();

  // ── each product's newest version, as the plugin's own update check reads it ───────────────────────────────
  var releases = [];
  root.querySelectorAll('.myp-ver').forEach(function (v) {
    var id = v.getAttribute('data-release');
    if (releases.indexOf(id) < 0) releases.push(id);
  });
  releases.forEach(function (id) {
    fetch(cat.service + '/v1/latest?product=' + encodeURIComponent(id)).then(function (r) { return r.json(); }).then(function (j) {
      if (!j || !j.ok || !j.latest) return;
      root.querySelectorAll('.myp-ver[data-release="' + id + '"]').forEach(function (v) {
        v.textContent = 'Version ' + j.latest;
        var news = v.closest('.myp-row').querySelector('.myp-new');
        if (news && j.url) news.innerHTML = ' <a href="' + esc(j.url) + '" target="_blank" rel="noopener">What\'s new in ' + esc(j.latest) + '</a>';
      });
    }).catch(function () {});
  });

  return done();

  function done() {                                        // ea-base.js watches what was on the page; tell it about the rows
    var s = document.getElementById('myp-section');
    if (s) s.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    root.setAttribute('data-ready', '1');
  }
})();
